import React from 'react';
import { ErrorDetailListProps } from '../components/errorDetailList/errorDetailList';
import { ServiceResponseError } from '../model/serviceResponse';

interface useErrorDetailListDialogResult {
  showErrorDetailListDialog: (
    shortMessage: string,
    errors: ServiceResponseError[] | null,
    id?: string | null
  ) => void;
  closeErrorDetailListDialog: () => void;
  errorDetailListDialogProps: ErrorDetailListProps;
}

const initialErrorDetailListDialogProps = {
  id: null,
  open: false,
  errors: [],
  shortMessage: '',
  onClose: () => null
};

export const useErrorDetailListDialog = (): useErrorDetailListDialogResult => {
  const [
    errorDetailListDialogProps,
    setErrorDetailListDialogProps
  ] = React.useState<ErrorDetailListProps>(initialErrorDetailListDialogProps);
  const showErrorDetailListDialog = (
    shortMessage: string,
    errors: any[] | null,
    id: string | null = null
  ) => {
    setErrorDetailListDialogProps({
      id: id,
      open: true,
      errors: errors,
      shortMessage: shortMessage,
      onClose: closeErrorDetailListDialog
    });
  };

  const closeErrorDetailListDialog = () => {
    setErrorDetailListDialogProps(initialErrorDetailListDialogProps);
  };

  return { showErrorDetailListDialog, closeErrorDetailListDialog, errorDetailListDialogProps };
};
